import { configureStore } from '@reduxjs/toolkit';
import analyticsReducer from './analyticsSlice'

export default configureStore({
    reducer: {
      analytics: analyticsReducer,
    },
  });
  